import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import apiClient from "common/src/api/ApiClient";


export const fetchDatasetPage = createAsyncThunk(
    'dataset/fetchPage',
    async ({page, filter, sort}, {rejectWithValue}) => {
        try {
            const response = await apiClient.get(`/api/v1/dataset/published`, null, page, filter, sort , false);
            return response.data.payload;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const fetchDataPreview = createAsyncThunk(
    'dataset/fetch/dataPreview',
    async ({id, isPublic, overrideParams}, thunkAPI) => {
        const overrideQuery = (overrideParams || []).map(param => `&${param}`).join("");
        const previewUrl = isPublic
            ? `/api/v1/data/public/${id}/preview?limit=10&offset=0${overrideQuery}`
            : `/api/v1/data/private/${id}/preview?limit=10&offset=0${overrideQuery}`;
        const response = await apiClient.get(previewUrl, null, null, null, null, false);
        return response.data;
    }
);

export const fetchCSVData = createAsyncThunk(
    'dataset/fetch/getCSVData',
    async ({ id, isPublic }, thunkAPI) => {
        try {
            const csvUrl = isPublic
                ? `/api/v1/data/public/${id}/csv`
                : `/api/v1/data/private/${id}/csv`;
            const response = await apiClient.getCSVFile(csvUrl, {}); // You may return necessary data if needed
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);
const datasetSlice = createSlice({
    name: 'dataset',
    initialState: {
        list: {},
        data: [],
        page: 0,
        totalPages: 0,
        loading: false,
        error: null,
        allDataLoaded: false,
        preview: {}
    },
    reducers: {
        clearDatasets: (state) => {
            state.data = [];
            state.list = {};
            state.page = 0;
            state.totalPages = 0;
            state.loading = false;
            state.allDataLoaded = false;
            state.preview = {};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDatasetPage.pending, (state) => {
                state.loading = true;
            })

            .addCase(fetchDatasetPage.fulfilled, (state, action) => {
                const {pageable, content, totalElements} = action.payload;
                const startIndex = pageable.pageNumber * pageable.pageSize;
                const endIndex = startIndex + content.length;
                state.list = action.payload;

                // Ensure data array is large enough to accommodate all elements
                if (state.data.length < totalElements) {
                    state.data = Array(totalElements).fill(null);
                }
                // Replace elements in data array with fetched content
                for (let i = startIndex; i < endIndex; i++) {
                    state.data[i] = content[i - startIndex];
                }

                state.page = pageable.pageNumber + 1;
                state.totalPages = Math.ceil(totalElements / pageable.pageSize);
                state.loading = false;
                if (pageable.pageNumber + 1 >= state.totalPages) {
                    state.allDataLoaded = true;
                }
            })
            .addCase(fetchDatasetPage.rejected, (state, action) => {
                 state.loading = action["error"]["message"] === "Request was aborted";
            })
            .addCase(fetchDataPreview.pending, (state, action) => {
                state.loadingPreview = true;
                if (action?.meta.arg?.id) {
                    state.preview[action.meta.arg.id] = {};
                    state.preview[action.meta.arg.id].loadingPreview = true;
                }
            })
            .addCase(fetchDataPreview.fulfilled, (state, action) => {
                state.loadingPreview = false;
                if (action?.meta.arg?.id) {
                    state.preview[action.meta.arg.id] = {};
                    state.preview[action.meta.arg.id].loadingPreview = false;
                    state.preview[action.meta.arg.id].data = action.payload;
                }
            })
            .addCase(fetchDataPreview.rejected, (state, action) => {
                state.loadingPreview = false;
                if (action?.meta.arg?.id) {
                    state.preview[action.meta.arg.id] = {};
                    state.preview[action.meta.arg.id].loadingPreview = false;
                }
            })
            .addCase(fetchCSVData.pending, (state, action) => {
                console.log('fetchCSVData.pending action?.meta.arg', new Date(), action?.meta?.arg);
                state.csvLoading = true;
                if (action?.meta.arg?.id) {
                    state[action?.meta.arg.id] = {};
                    state[action?.meta.arg.id].csvLoading = true;
                }
        })
            .addCase(fetchCSVData.fulfilled, (state,action) => {
                console.log('fetchCSVData.fulfilled action?.meta.arg', new Date(), action?.meta?.arg);
                state.csvLoading = false;
                if (action?.meta.arg?.id) {
                    state[action?.meta.arg.id] = {};
                    state[action?.meta.arg.id].csvLoading = false;
                }
                try {
                    const blob = new Blob([action.payload], {type: 'text/csv'});
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = "data.csv"

                    if (action?.meta.arg?.name) {
                        fileName = action?.meta.arg?.name + '.csv';
                    } else if (action?.meta.arg?.id) {
                        fileName = (state.list.content.find(item => item.id === action?.meta.arg?.id)?.name || 'data') + '.csv';
                    }
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch(error) {
                    console.error('CSV download error:', error);
                }
            })
            .addCase(fetchCSVData.rejected, (state, action) => {
                console.log('fetchCSVData.rejected action?.meta.arg', new Date(), action?.meta?.arg);
                state.csvLoading = false;
                if (action?.meta.arg?.id) {
                    state[action?.meta.arg.id] = {};
                    state[action.meta.arg.id].csvLoading = false;
                }
            });
    },
});

export const {clearDatasets} = datasetSlice.actions;
export default datasetSlice.reducer;
